// Account socket message types. The account channel is server-to-client only.
// State messages carry absolute values, so a repeated or late one never double
// counts; notices are one-off prompts with nothing to reconcile.
export const ACCOUNT_SOCKET_PATH = '/account';
// Close code for a socket with no valid session (none, expired, or signed
// out). Clients do not retry it; they re-check the session instead.
export const ACCOUNT_SOCKET_NO_SESSION = 4401;
export var AccountServerMessageType;
(function (AccountServerMessageType) {
    AccountServerMessageType["SNAPSHOT"] = "snapshot";
    AccountServerMessageType["LOON_BALANCE"] = "loonBalance";
    AccountServerMessageType["ACHIEVEMENT_PROGRESS"] = "achievementProgress";
    AccountServerMessageType["POPPY_CHAT_LINK_BLOCKED"] = "poppyChatLinkBlocked";
})(AccountServerMessageType || (AccountServerMessageType = {}));
export function isAccountServerMessage(message) {
    return (typeof message === 'object' &&
        message !== null &&
        'type' in message &&
        'payload' in message &&
        Object.values(AccountServerMessageType).includes(message.type));
}
//# sourceMappingURL=accountMessages.js.map